import React from 'react';

import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './tabs.component.module.styl';


const classes = hashedClasses(styles);

export const TabsSeparator = () => (
    <li role="presentation" className={classes.tabs__separator} aria-hidden={true}/>
);

TabsSeparator.displayName = 'TabsSeparator';
